module.exports = __webpack_public_path__ + "img/ForestOutlined.10a76a0a.svg";